import { useRouter } from 'next/router';
import React from 'react';

import { connect } from 'react-redux';

import { LayoutConsumePropsType } from '@/models/globalModels';
import { doActiveLayout, doActiveLayoutItem } from '@/redux/layout/actions';
import { RootState } from '@/redux/rootReducer';

const mapStateToProps = (state: RootState) => {
  const layout = state.layout;
  return {
    layout,
  };
};

const mapDispatchToProps = {
  doActiveLayout,
  doActiveLayoutItem,
};

const LayoutConsume = ({ children, menuActive, itemActive, doActiveLayout, doActiveLayoutItem }: LayoutConsumePropsType) => {
  const router = useRouter();
  React.useEffect(() => {
    doActiveLayout(menuActive);
    // Convert itemActive in Array Value
    if (itemActive) doActiveLayoutItem(Array.isArray(itemActive) ? itemActive : [itemActive]);
  }, [itemActive]);

  React.useEffect(() => {
    if (router.pathname.includes('register')) {
      document.body.classList.add('register-page');
    }
    return () => {
      document.body.classList.remove('register-page');
    };
  }, [router.pathname]);

  return children;
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutConsume);
